import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Homepage from './components/Homepage';
import Login from './components/Login';
import Register from './components/Register';
import VerifyEmail from './components/VerifyEmail';
import AdminDashboard from './components/AdminDashboard';
import SuperAdminDashboard from './components/SuperAdminDashboard';
import CreateClub from './components/CreateClub';
import ClubDetails from './components/ClubDetails';
import PartnerWithUs from './components/PartnerWithUs';
import ProtectedRoute from './components/ProtectedRoute';
import AboutUs from './components/AboutUs';
import FindClubs from './components/FindClubs';
import Events from './components/Events';
import Blog from './components/Blog';
import HelpCenter from './components/HelpCenter';
import ContactUs from './components/ContactUs';
import FAQ from './components/FAQ';
import CommunityGuidelines from './components/CommunityGuidelines';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import CookiePolicy from './components/CookiePolicy';
import Accessibility from './components/Accessibility';
import Pricing from './components/Pricing';
import BoardGames from './components/BoardGames';
import BoardGameDetail from './components/BoardGameDetail';
import Discussions from './components/Discussions';
import DiscussionDetail from './components/DiscussionDetail';
import NewDiscussion from './components/NewDiscussion';
import { CityProvider } from './contexts/CityContext';
import './App.css';

function App() {
  return (
    <CityProvider>
    <Router>
      <div className="App">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Homepage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/clubs/:id" element={<ClubDetails />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/find-clubs" element={<FindClubs />} />
          <Route path="/events" element={<Events />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/help" element={<HelpCenter />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/community-guidelines" element={<CommunityGuidelines />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/accessibility" element={<Accessibility />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/partner-with-us" element={<PartnerWithUs />} />

          {/* Board Games Routes */}
          <Route path="/board-games" element={<BoardGames />} />
          <Route path="/board-games/:slug" element={<BoardGameDetail />} />

          {/* Discussions Routes */}
          <Route path="/discussions" element={<Discussions />} />
          <Route path="/discussions/new" element={<NewDiscussion />} />
          <Route path="/discussions/:slug" element={<DiscussionDetail />} />

          {/* Protected Club Management Routes - requires club_owner role */}
          <Route 
            path="/club-management" 
            element={
              <ProtectedRoute clubOwnerOnly={true}>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />

          {/* Super Admin Dashboard - requires super_admin role */}
          <Route 
            path="/super-admin" 
            element={
              <ProtectedRoute superAdminOnly={true}>
                <SuperAdminDashboard />
              </ProtectedRoute>
            } 
          />

          {/* Redirect old routes to appropriate pages */}
          <Route path="/dashboard" element={<Navigate to="/" replace />} />
          <Route path="/admin/dashboard" element={<Navigate to="/club-management" replace />} />

          <Route 
            path="/admin/create-club" 
            element={
              <ProtectedRoute clubOwnerOnly={true}>
                <CreateClub />
              </ProtectedRoute>
            } 
          />

          {/* Catch all - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
    </CityProvider>
  );
}

export default App;